import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-chem-soft/80 px-5 py-8" data-id="element-324" data-mp="hqrqo540h25f">
      <div className="mx-auto max-w-3xl text-center" data-id="element-325" data-mp="1c0np7xqxngf1">
        <p className="text-sm font-medium text-chem-deep sm:text-base" data-id="element-326" data-mp="1c28h1flv4l97">
          Materiały po polsku • Gotowe do druku • Dla klas 7–8, liceum i technikum
        </p>
      </div>
    </section>;
}